import { render, staticRenderFns } from "./XCoinsAgreement.vue?vue&type=template&id=329b37e9&scoped=true&"
import script from "./XCoinsAgreement.vue?vue&type=script&lang=js&"
export * from "./XCoinsAgreement.vue?vue&type=script&lang=js&"
import style0 from "./XCoinsAgreement.vue?vue&type=style&index=0&id=329b37e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329b37e9",
  null
  
)

export default component.exports